import { STARTED, SUCCEEDED, FAILED } from 'redux-request-state/requestStates';
const actionsToArtifacts = {};
export const registerRequestTypes = requestTypes => {
  actionsToArtifacts[requestTypes.REQUESTED] = () => ({
    requestKey: requestTypes.key,
    requestState: STARTED
  });
  actionsToArtifacts[requestTypes.SUCCEEDED] = () => ({
    requestKey: requestTypes.key,
    requestState: SUCCEEDED
  });
  actionsToArtifacts[requestTypes.FAILED] = ({
    payload: {
      error: {
        status,
        responseJSON = {}
      }
    }
  }) => ({
    requestKey: requestTypes.key,
    requestState: FAILED,
    error: {
      status,
      message: responseJSON.message
    }
  });
};
export default actionsToArtifacts;